export const API_URL = 'https://restaurantsystemapigateway.onrender.com'; 